import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FireInsuranceBroker } from '@models/brokerage';
import { Store } from '@ngxs/store';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';

@Component({
	selector: 'app-edit-fire-insurance-broker',
	templateUrl: './edit-fire-insurance-broker.component.html',
	standalone: false,
})
export class EditFireInsuranceBrokerComponent {
	public matterId = this.store.selectSnapshot(SelectedMatter.id);
	public fireInsuranceBrokerage = this.store.selectSnapshot(
		SelectedMatter.fireInsuranceBrokerage,
	);
	public fireInsuranceBroker: FireInsuranceBroker;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private store: Store,
		private navigationService: NavigationService,
		private matterDispatch: MatterDispatch,
	) {
		this.fireInsuranceBroker =
			this.router.getCurrentNavigation()?.extras?.state?.fireInsuranceBroker;

		if (!this.fireInsuranceBroker) {
			this.navigationService.goBack(this.route);
		}
	}

	_onSubmit(fireInsuranceBroker: FireInsuranceBroker) {
		this.matterDispatch.CreateFireInsuranceBroker(
			this.matterId,
			this.fireInsuranceBrokerage.id,
			fireInsuranceBroker,
		);
		this.navigationService.goBack(this.route);
	}

	_onCancel() {
		this.navigationService.goBack(this.route);
	}
}
